// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iWPO","colMin":"styles_colMin__JNtEv"};